<template>
    <div>
        <v-container>
            <div class="d-flex align-center">
                <h1>Jobs</h1>
                <v-btn color="primary" class="refresh-button" @click="refresh()" text>
                    <v-icon left dark>mdi-reload</v-icon>
                    Refresh jobs
                </v-btn>
            </div>
            <v-progress-linear :indeterminate="true" v-if="loading" />

            <v-row>
                <v-col cols="12" md="6" lg="4" v-for="j in jobs" :key="j.key">
                    <v-card>
                        <v-card-title>{{ j.title }}</v-card-title>
                        <v-card-subtitle v-if="j.isRunning">{{ j.message }}</v-card-subtitle>
                        <v-card-subtitle v-if="!j.isRunning">
                            <div>Last run: {{ j.success || j.failed ? moment(j.success || j.failed).fromNow() : "Never" }}</div>
                            <div>Next run: {{ j.interval > 0 ? moment(j.success || j.failed).add(j.interval, "seconds").fromNow() : "Manual" }}</div>
                        </v-card-subtitle>
                        <v-divider />
                        <v-card-actions>
                            <v-chip v-if="j.isRunning" outlined>
                                <v-progress-circular :indeterminate="true" color="primary" size="20" width="2" style="margin-right:5px" />
                                Running...
                            </v-chip>
                            <v-chip v-if="!j.isEnabled" text-color="red" outlined>Disabled</v-chip>
                            <v-chip v-if="j.isEnabled && !j.isRunning && j.failed" text-color="red" outlined>Failed</v-chip>
                            <v-chip v-if="j.isEnabled && !j.isRunning && j.success" text-color="green" outlined>Completed</v-chip>
                            <v-spacer />
                            <v-btn color="primary" @click="start(j)" dark depressed :disabled="j.isRunning || !j.isEnabled">
                                <v-icon left dark>mdi-run</v-icon>
                                Run
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { api } from '@/services/api';
import toast from "@/services/toast";
import TimerMixin from "@/mixins/Timer";
import moment from "moment";

export default {
    data: () => ({
        jobs: [],
        waiting: 0,
    }),
    mixins: [TimerMixin],
    created: function() {
        this.refresh();
        this.loading = false;
    },
    mounted() {
        this.timer(5000, async () => {
            if (this.jobs.some(j => j.isRunning))
                await this.refresh();
        });
    },
    methods: {
        moment,
        duration: moment.duration,
        async start(job) {
            job.isRunning = true;
            job.message = "Starting...";

            await api("/admin/jobs/start", { id: job.id });

            toast(`Started job '${job.title}'`);
        },
        async refresh() {
            this.jobs = await api("/admin/jobs/list", { });
        }
    }
};
</script>